import { motion } from "framer-motion";
import { Landmark, CreditCard } from "lucide-react";
import {
  PAYMENT_INTRO,
  PAYMENT_METHODS,
  PAYMENT_DISCLAIMER,
} from "@/data/content";
import { useT } from "@/i18n/LanguageContext";

const METHOD_ICONS = { Landmark, CreditCard };

export const Payment = () => {
  const t = useT();

  return (
    <section id="payment" data-testid="payment-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span className="uppercase text-xs tracking-[0.25em] text-[#1A1A1F] font-bold">
            {t(PAYMENT_INTRO.eyebrow)}
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mt-4">
            {t(PAYMENT_INTRO.title)}
          </h2>
        </motion.div>

        <p data-testid="payment-summary" className="mt-8 max-w-3xl text-[#62646B] leading-relaxed">
          Each package is reserved with a refundable deposit, followed by a transparent
          monthly plan after regulatory approval. Specific amounts depend on the property
          batch and are shown on the property reservation step.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 mt-8">
          {PAYMENT_METHODS.map((m, i) => {
            const Icon = METHOD_ICONS[m.icon];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`payment-method-${i}`}
                className="flex items-start gap-4 p-6 rounded-3xl bg-white border border-[#E8E7E2]"
              >
                <div className="w-12 h-12 rounded-2xl border border-[#E8E7E2] flex items-center justify-center bg-[#FAFAF7] shrink-0">
                  {Icon && <Icon size={20} className="text-[#1A1A1F]" />}
                </div>
                <div>
                  <h4 className="font-heading text-lg font-medium">{t(m.title)}</h4>
                  <p className="text-sm text-[#62646B] mt-1.5">{t(m.desc)}</p>
                </div>
              </motion.div>
            );
          })}
        </div>

        <p
          data-testid="payment-disclaimer"
          className="text-xs text-[#8A8F9C] leading-relaxed mt-10 max-w-3xl"
        >
          {t(PAYMENT_DISCLAIMER)}
        </p>
      </div>
    </section>
  );
};
